import { StripeElements } from './StripeElements';
export { StripeElements };

customElements.define(StripeElements.is, StripeElements);
